<template>
  <div class="age-filters" v-if="showGroup">
    <h5>{{ title }}</h5>
    <el-checkbox-group
      :class="{ 'long-group': isLong, 'short-group': !isLong }"
      v-model="selectedOptions"
      @change="handleChange"
    >
      <el-row :gutter="20" v-if="chunk">
        <el-col :span="12">
          <div v-for="option in chunkedOptions[0]" :key="getItem(option, valueKey)">
            <virtual-list :size="virtualListSize" :remain="virtualListVisible">
              <el-checkbox :label="getItem(option, valueKey)">
                <slot :option="option">
                  <span class="option">{{ option }}</span>
                </slot>
              </el-checkbox>
            </virtual-list>
            <br />
          </div>
        </el-col>
        <el-col :span="4">
          <div
            v-for="option in chunkedOptions[1]"
            :key="getItem(option, valueKey)"
            class="overflow-text"
          >
            <virtual-list :size="virtualListSize" :remain="virtualListVisible">
              <el-checkbox :label="getItem(option, valueKey)"
                ><slot :option="option">
                  <span class="option">{{ option }}</span>
                </slot></el-checkbox
              >
            </virtual-list>
            <br />
          </div>
        </el-col>
      </el-row>
      <div v-else>
        <virtual-list :size="virtualListSize" :remain="virtualListVisible">
          <div v-for="option in options" :key="getItem(option, valueKey)">
            <el-checkbox :label="getItem(option, valueKey)">
              <el-row>
                <slot :option="option">
                  <span class="option">{{ option }}</span>
                </slot>
              </el-row>
            </el-checkbox>
          </div>
        </virtual-list>
        <br />
      </div>
    </el-checkbox-group>
  </div>
</template>

<script>
import { isEmpty, get, isObject, chunk } from 'lodash';
import VirtualList from 'vue-virtual-scroll-list';

export default {
  name: 'FilterGroup',
  components: {
    VirtualList,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    path: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
    labelKey: {
      type: String,
      default: null,
    },
    valueKey: {
      type: String,
      default: null,
    },
    chunk: {
      type: Boolean,
      default: false,
    },
    virtualListSize: {
      type: Number,
      default: 2,
    },
    virtualListVisible: {
      type: Number,
      default: 12,
    },
    isLong: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedOptions: [],
  }),
  computed: {
    chunkedOptions() {
      const CHUNK_SIZE = Math.floor(this.options.length / 2);
      return chunk(this.options, CHUNK_SIZE);
    },
    showGroup() {
      return !isEmpty(this.options);
    },
  },
  methods: {
    getItem(value, key) {
      return isObject(value) ? get(value, key) : value;
    },
    handleChange() {
      this.$emit('change', [this.path, this.selectedOptions]);
    },
    reset() {
      this.selectedOptions = [];
      this.handleChange();
    },
    apply(filter) {
      const options = get(filter, this.path, []);
      this.selectedOptions = options;
    },
  },
};
</script>

<style scoped>
h5 {
  color: #c2c5cc;
}

.long-group {
  height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 10px;
  margin-right: 4px;
}

.short-group {
  height: 180px;
  overflow-y: hidden;
  overflow-x: hidden;
  margin-bottom: 14px;
}

.option {
  font-size: 0.9em;
}
</style>



// WEBPACK FOOTER //
// FilterGroup.vue?40433336